import React, { Component } from 'react';
import { Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ActionStatus, GamePlayerStatus } from '../../../../../Constants';
import { getCardTextureUrl } from '../../../Common/TextureTools';
import FireIcon from '../../../Common/FireIcon';

import '../../../Choices/draft-choice.css'


export default class DraftSelector extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.gamePlayerData.status === GamePlayerStatus.PICK_DRAFT_ID;
    }

    onClick = (swiper) => {
        let guestCardId = this.props.gameData.draft_choices[swiper.clickedIndex];
        this.api.clickDraftChoice(guestCardId);
    }

    render() {
        if (this.props.gamePlayerData.status !== GamePlayerStatus.PICK_DRAFT_ID) return <></>
        return <>

            <Swiper
                slidesPerView={2}
                spaceBetween={0}
                // freeMode={true}
                grabCursor={true}

                modules={[Virtual]}

                onSwiper={(swiper) => {
                    this.swiper = swiper;
                }}
                onClick={this.onClick}
                className="draft-swiper"
            >
                {this.props.gameData.draft_choices.map((cardId, index) => {
                    return <SwiperSlide key={`gi-${index}`}
                                        virtualIndex={index}>
                        <div className={'draft-border-dashed'} />
                        <img
                            src={getCardTextureUrl(cardId)}
                            alt="card"
                            className={'draft-card-img'}
                        />
                        <FireIcon className={'draft-will-burn'}/>
                    </SwiperSlide>
                })}
            </Swiper>
        </>;
    }

}
